{
    "webhooks": {
        "newWebhook": "New Webhook",
        "name": "Webhook Name",
        "description": "Description",
        "editWebhook": "Edit Webhook",
        "webhookDetails": "Webhook Details",
        "messages": {
            "deleteWebhookConfirmation": "Do you want to delete the webhook {webhookName}?",
            "deleteWebhookSuccess": "Webhook deleted successfully",
            "webhookNameExists": "Webhook name {webhookName} already exists!",
            "webhookNameRequired": "Webhook name is required",
            "workflowRequired": "Select a workflow from the dropdown menu",
            "copied": "Copied to clipboard",
            "copyError": "Failed to copy",
            "success": "Webhook saved successfully",
            "errorOccurred": "An error occurred while saving the webhook"
        },
        "title": "Webhooks",
        "webhookName": "Webhook Name",
        "workflow": "Workflow",
        "webhookUrl": "Webhook URL",
        "tokenUrl": "Webhook URL (with token)",
        "triggerHelp": "Send a POST request to the URL below to trigger this workflow.",
        "basicAuthFallback": "Use Basic Auth instead",
        "username": "Username",
        "password": "Password",
        "token": "Token",
        "active": "Active",
        "inactive": "Inactive",
        "restrictedAccess": "Restricted Access",
        "invalidWorkflow": "Invalid Workflow",
        "activateSuccess": "Webhook activated successfully",
        "deactivateSuccess": "Webhook deactivated successfully",
        "createWebhook": "Create Webhook",
        "noWebhooks": "No webhooks configured for this workflow"
    },
    "groups": {
        "title": "Groups",
        "noGroupedFields": "No grouped fields found",
        "newGroup": "New Group",
        "editGroup": "Edit Group",
        "groupName": "Group Name",
        "workflows": "Workflows",
        "roles": "Roles",
        "selectWorkflows": "Select Workflows",
        "tooltip": "Select order of workflows to be shown in the VXL Live",
        "selected": "Selected Workflows",
        "workflowName": "Workflow Name",
        "createdByUser": "Created By",
        "modifiedBy": "Modified By",
        "created": "Created",
        "modified": "Modified",
        "messages": {
            "groupNameRequired": "Group name is required.",
            "groupNameExists": "Group {groupName} already exists!",
            "groupNameCheckFailed": "Could not verify the group name. Please try again.",
            "rolesRequired": "At least one role must be selected.",
            "deleteGroupConfirmation": "Are you sure you want to delete the group '{groupName}'?",
            "deleteGroupSuccess": "Group deleted successfully.",
            "success": "Group saved successfully.",
            "workflowsRequired": "At least one workflow must be selected."
        }
    },
    "workflows": {
        "roles": "Roles",
        "nameIsNotUnique": "Workflow with such name already exists",
        "nameNotPermitted": "You do not have permission to create a workflow with this name",
        "nameIsRequired": "Field is mandatory",
        "nameHasSpecialChars": "Special characters: / $ * ? {'{'} {'}'} [ ] & % are not allowed",
        "workflowTypeOptions": {
            "EXPRESS": "Express",
            "STANDARD": "High Volume"
        },
        "type": "Workflow Type",
        "connectionName": "Connection Name",
        "connectionDescription": "Connection Description",
        "authenticationType": "Authentication Type",
        "protocol": "Protocol",
        "baseURI": "Base URI",
        "tokenURI": "Token URI",
        "autofillDetails": "Autofill Details from File",
        "grantType": "Grant Type",
        "scope": "Scope",
        "resource": "Resource",
        "audience": "Audience",
        "ignoreCertificateErrors": "Ignore Certificate Errors",
        "useStaticIP": "Use Static IP",
        "useDedicatedIP": "Use Dedicated IP",
        "useM3UserId": "Use M3 User ID",
        "M3Company": "M3 Company",
        "designFile": "Design File",
        "designFileSaved": "Design file updated successfully",
        "workflowTimeline": {
            "currentlyRunning": "Currently running...",
            "completedIn": "completed in"
        },
        "lookupWorkflow": "<strong>Lookup:</strong> {lookup}   <strong>Workflow :</strong> {workflow}",
        "notification": {
            "status": {
                "finished": "completed",
                "started": "started",
                "stepcomplete": "progressing",
                "failed": "failed"
            },
            "view": "View",
            "workflow": "Workflow {workflowName} {status}"
        },
        "runWorkflow": {
            "errors": {
                "hasError": "Workflow configuration has errors - cannot execute",
                "noEnvironments": "No environments available for execution",
                "noConnections": "No connections available for execution",
                "connectionsLoadFailed": "Failed to load connections",
                "environmentsLoadFailed": "Failed to load environments"
            },
            "execute": "Execute",
            "tooltips": {
                "openLookupDialog": "Open Lookup"
            },
            "file": "File",
            "selectFile": "Select file",
            "executionTimeline": "Execution timeline:",
            "exclude": "Ignore field",
            "finished": "Workflow execution completed successfully",
            "failed": "Workflow execution failed",
            "logLevel": "Log level for execution",
            "advancedConfig": "Advanced config",
            "inputData": "Input Data (JSON)",
            "downloadTemplate": "Download excel template",
            "close": " & close",
            "title": "Run workflow",
            "environment": "Select environment"
        },
        "unsavedChanges": "Unsaved step changes",
        "unsavedPopover": {
            "title": "Unsaved Changes",
            "message": "You have unsaved changes to the workflow \"{title}\", do you want to save the workflow?",
            "saveAndContinue": "Save and Continue"
        },
        "configurationExecutionKeys": "Configuration Execution Keys ({current}/{maximum})",
        "keyName": "Name",
        "expression": "JSONata Expression",
        "addNewExecutionKey": "New Key",
        "validation": {
           "keyNameRequired": "Key name is required",
           "invalidExpression": "Invalid JSONata expression",
           "expressionRequired": "Expression is required"
        },
        "unsavedChangesMessage": "There are unsaved changes in step configuration. Are you sure that you want to discard these and switch step now?",
        "importWorkflow": "Import Workflow",
        "importWorkflowTooltip": "When selected, this workflow is configured to import/upload data from an Excel spreadsheet upon execution. The workflow will process the uploaded data and trigger the associated APIs. These APIs may perform either import or export operations depending on the workflow configuration.",
        "active": "Active Workflow",
        "structureUpdate": "Modifying workflow structure...",
        "deleteStep": "Delete step",
        "deleteLastStepError": "The last workflow step cannot be deleted. \n Add another step first, or delete the entire workflow",
        "deleteStepMessage": "Are you sure that you want to delete {stepName}?",
        "deleteStepCompleted": "Step deleted",
        "addStep": "Add workflow step",
        "stepUpdateCompleted": "Step execution config updated",
        "stepExecutionConfig": "Step execution config",
        "retryAttempts": "Retries",
        "genericFilter": {
            "filterFieldPlaceholder": "Specify {fact} to filter",
            "datatype": "Data type",
            "dataTypeOptions": {
                "STRING": "String",
                "NUMBER": "Number",
                "BOOLEAN": "Boolean"
            },
            "logicalOperator": "Logical operator",
            "value": "Value",
            "comparison": "Comparison",
            "source": "Source",
            "sourceOptions": {
                "CLIENT": "Client",
                "CONSTANT": "Constant"
            },
            "comparisonOptions": {
                "equal": "Equal",
                "notEqual": "Not equal",
                "lessThan": "Less than",
                "lessThanInclusive": "Less than inclusive",
                "greaterThan": "Greater than",
                "greaterThanInclusive": "Greater than inclusive",
                "isBlank": "Is blank",
                "isNotBlank": "Is not blank",
                "stringContains": "Contains",
                "stringNotContains": "Does not contain"
            },
            "messages": {
                "constantRequired": "Value for constant filter item is required"
            },
            "fact": "Field",
            "title": "Generic filter",
            "add": "Add filter item"
        },
        "table": {
            "commandType": {
                "UPSERT": "Upsert",
                "REPLACE": "Replace",
                "APPEND": "Append"
            },
            "messages": {
                "tableNameAlreadyExists": "Table name already exists",
                "tableNameRequired": "Table name is required. Use Table Info to set it",
                "tableDescriptionRequired": "Table description is required. Use Table Info to set it",
                "pkColumnRequired": "At least one column marked as primary key is required"
            },
            "command": "Update mode",
            "tableInfo": "Table info",
            "editTableInfo": "Edit table info",
            "tableName": "Table name",
            "tableDescription": "Table description",
            "title": "Custom table",
            "singleTable": "Single table",
            "perEnvironment": "Per environment",
            "isPK": "Primary key",
            "isNotPK": "Not primary key",
            "primaryKey": "Primary key",
            "dataType": "Data type",
            "columnName": "Internal column name",
            "description": "Description",
            "editColumn": "Edit column",
            "openFields": "Show available fields",
            "closeFields": "Close fields list",
            "columns": "Columns",
            "dragItems": "Table currently does not have any columns",
            "clickToShow": "Click here to show available workflow fields that can be columns",
            "dropBelow": "Drag item below to add column",
            "showRecentWorkflows": "Show recently viewed workflows",
            "hideRecentWorkflows": "Hide recently viewed workflows",
            "sortByFavorites": "Sort by favorites",
            "clearFavoriteSort": "Clear favorite sort"
        },
        "tableUpdater": {
            "title": "Table Updater",
            "pksMessage": " Please note that the output from the previous step should have following keys: {pkColumns}",
            "table": "Table",
            "singleTable": "Single table",
            "perEnvironment": "Per environment",
            "defaultTable": "Default table",
            "defaultTablePlaceholder": "Fallback table if environment has no override",
            "messages": {
                "tableRequired": "Table required",
                "tableRequiredForEnvs": "Table required for environments: {envs}"
            }
        },
        "m3Fetch": {
            "title": "M3 Fetch"
        },
        "dataLake": {
            "title": "Data lake",
            "connectionId": "Connection",
            "connectionPlaceholder": "Select or type a connection ID...",
            "endpoint": "Endpoint URL",
            "endpointPlaceholder": "https://api.example.com/path",
            "body": "Query",
            "bodyPlaceholder": "Enter your query...",
            "advanced": "Advanced",
            "saveAsFile": "Also save output as file"
        },
        "fileUploader": {
            "messages": {
                "connectionRequired": "Connection is required",
                "itemRequired": "Path is required"
            },
            "title": "File loader",
            "connection": "Connection",
            "webUrl": "Path",
            "browse": "Browse"
        },
        "converter": {
            "format": {
                "json": "JSON",
                "xml": "XML",
                "csv": "CSV"
            },
            "title": "Converter",
            "source": "Source:",
            "target": "Target:",
            "noConfig": "No configuration for selected format",
            "saveAsFile": "Also save output as file",
            "trimHeaderFields": "Trim header fields",
            "prependHeader": "Prepend header",
            "trimFieldValues": "Trim values",
            "emptyFieldValue": "Empty field value",
            "eolDelimiter": "Delimiter end of line",
            "wrapDelimiter": "Delimiter wrap",
            "fieldDelimiter": "Delimiter field",
            "rootElement": "Root element",
            "attributeNamePrefix": "Attribute name prefix",
            "ignoreNamespace": "Ignore namespace",
            "ignoreAttributes": "Ignore attributes"
        },
        "email": {
            "sourceType": {
                "NONE": "None",
                "FILE": "Generated files",
                "DATA": "Raw output"
            },
            "noFileSourceSteps": "No steps before this one can produce a file",
            "sourceTypeHint": {
                "FILE": "Attach a file produced by a compatible earlier step (e.g. {stepNames})",
                "DATA": "Attach the raw output data from an earlier step in JSON format"
            },
            "body": "Body",
            "sourceStep": "Source step for data",
            "noSourceSteps": "No source steps that can produce data available",
            "addresses": "Addresses",
            "content": "Email content",
            "attachment": "Attachments",
            "isHTML": "HTML",
            "htmlHelp": "Should be selected if the user is using any HTML code in Transform or Email steps.",
            "editorTabs": {
                "visual": "Visual editor",
                "html": "HTML Editor",
                "preview": "Preview"
            },
            "toolbar": {
                "heading": "Heading",
                "subheading": "Subheading",
                "normal": "Normal"
            },
            "attachmentIndicators": {
                "none": "--",
                "data": "<>"
            },
            "subject": "Subject",
            "invalidEmail": "Invalid email",
            "to": "To",
            "addCc": "Add cc addresses",
            "cc": "Cc",
            "bcc": "Bcc",
            "addBcc": "Add bcc addresses",
            "title": "Email sender",
            "fieldNames": {
                "toAddress": "To address",
                "subject": "Subject",
                "body": "Body"
            },
            "requiredFieldsWarning": "Please fill {fields} or remove the Email step."
        },
        "excel": {
            "selectAll": "Select All",
            "showSelected": "Show Selected",
            "fromSource": "From {source}",
            "dataTypeHeader": "Select data type",
            "dataType": "Data type",
            "setDataType": "Set data type",
            "includeBlankFalse": "Do not include blank",
            "includeBlankTrue": "Include blank",
            "defineCommonCellsStyle": "Set common cells style",
            "commonCellsStyle": "Common cells style",
            "initializing": "Preparing excel editor...",
            "isControlSpreadSheetEnabled": "Control spreadsheet",
            "importWorkflowRequiredMessage": "To use input Excel mapping, this workflow must be configured as an Import Workflow.\nWould you like to enable Import Workflow?",
            "isEnforceSheetVerificationEnabled": "Enforce sheet verification",
            "saveBackup": "Save backup of output",
            "sheetName": "Sheet name",
            "title": "Excel",
            "config": "Config",
            "excelSettings": "Settings",
            "descriptionRow": "Description row",
            "mappingRow": "Mapping row",
            "dataRow": "Data start",
            "rowStyle": "Define row style",
            "unsetMappingRow": "Unmark as mapping row",
            "setMappingRow": "Mark as mapping row",
            "setDescriptionRow": "Mark as description row",
            "setDataRow": "Mark as data start",
            "moveUp": "Move data row up",
            "moveDown": "Move data row down",
            "backColor": "Background",
            "color": "Foreground",
            "borderColor": "Border",
            "underline": "Underline",
            "bold": "Bold",
            "italic": "Italic",
            "textAlign": "Text alignment",
            "font": "Font",
            "colors": "Colors",
            "fontSize": "Font Size",
            "rowStyleTitle": "Row style",
            "cellStyle": "Cell style",
            "fontSizeUnit": "px",
            "stylePreview": "Style preview",
            "cellStyleTitle": "Cell style",
            "setCellStyle": "Style",
            "delete": "Clear cell",
            "removeColumn": "Remove mapping",
            "removeColumnsAfter": "Remove mappings to the right ",
            "sortedColumn": "Sorting order for this column",
            "addSortByColumn": "Sort by column",
            "removeSortByColumn": "Remove sorting by column",
            "availableParameters": "Available parameters",
            "apiParameters": "Add parameters",
            "showMappingValues": "Show mapping values",
            "hideMappingValues": "Hide mapping values",
            "inputs": "Inputs",
            "outputs": "Outputs",
            "inputLayoutDirectionHeader": "Layout direction",
            "inputLayoutDirection": "Layout direction for {count} inputs",
            "inputsDoNotFit": "Not enough space to layout all fields",
            "horizontalNoLeftColumn": "Horizontal layout needs a column to the left of the drop cell for the field label",
            "processingFields": "Processing {count} fields...",
            "processingWait": "This may take a few seconds",
            "largeColumnCountWarning": "You have mapped a large number of columns ({count}). This may exceed system limits and cause the save to fail.",
            "horizontal": "Horizontally",
            "vertical": "Vertically",
            "allColumnAfter": "Add empty column to the right",
            "allColumnBefore": "Add empty column to the left",
            "fieldsAddModeHeader": "Add fields",
            "fieldsAddMode": "Adding {count} fields starting from '{column}' column",
            "replace": "Replace existing columns",
            "addColumns": "Insert as new columns",
            "addMappingsToSameColumn": "Map to same column",
            "deleteColumn": "Delete column",
            "closeParameters": "Close parameters",
            "groupByColumn": "Column used in group by",
            "addGroupByColumn": "Group by column",
            "removeGroupByColumn": "Remove group by column",
            "files": "Files",
            "editCell": "Edit cell",
            "template": {
                "file": "Template file",
                "title": "Select a Template File",
                "chooseFile": "Choose File",
                "selectFromOnedrive": "Select from Onedrive",
                "fileDescription": "File must be excel format",
                "autoMap": "Automap M3 Input Fields",
                "autoMapTooltip": "Fields in the columns will automatically populate according to the input provided in M3",
                "headerStyle": "Header Style",
                "singleHeader": "Description row (D)",
                "doubleHeader": "Mapping row (M)",
                "toggleHeader": "Toggle Header",
                "templateAsDesign": "Use Template as Design File",
                "templateAsDesignConfirm": "Do you want to use this as design file as well?",
                "designTemplate": "Choose Design Template",
                "error": "Couldn't save template. Try again later.",
                "selectError": "Please select a file."
            },  
            "preview": {
                "sourceSheet": "Source Sheet",
                "headerRow": "Mapping row",
                "secondaryHeaderRow": "Description row",
                "dataRow": "Data Row",
                "applyTooltip": "Mapping or description rows have been changed. Click here to rerun automapping.",
                "startColumn": "Start Column",
                "endColumn": "End Column",
                "columnRange": "Column Range",
                "targetSheet": "Target Sheet",
                "addTargetSheet": "Add Target Sheet",
                "removeTargetSheet": "Remove Target Sheet",
                "targetSheetWarning": "Source and target sheets cannot be the same. Please select different sheets for source and target.",
                "sheetView": "Sheet view",
                "sourceLabel": "Source",
                "targetLabel": "Target",
                "validation": {
                    "headerOrMappingRequired": "At least one of Mapping or Description row is required.",
                    "headerAndMappingSameRow": "Mapping and Description rows cannot be the same.",
                    "dataRowAfterHeader": "Data Row must come after the Mapping row.",
                    "dataRowAfterMapping": "Data Row must come after the Description row.",
                    "dataRowRequired": "Data Row is required.",
                    "applyRowsZero": "Row numbers should not be zero or less than zero.",
                    "applyRowsConflict": "Data row must come after Description and Mapping rows.",
                    "unappliedRowChangesSource": "Source tab has unapplied row changes. Please click ✓ to apply them.",
                    "unappliedRowChangesTarget": "Target tab has unapplied row changes. Please switch to the Target tab and click ✓ to apply them.",
                    "unappliedRowChangesBoth": "Source and Target tabs have unapplied row changes. Please click ✓ on each tab to apply them."
                }
            },
            "design": "Design file",
            "designTooltip": "This file will be available in VXL live as template for execution",
            "noFile": "No file uploaded",
            "upload": "Upload new file",
            "showMappingInfo": "Mapping info",
            "mappingInfo": "Parameters mapped to column {column}:",
            "unmapAll": "Remove all mappings",
            "mainMapping": "Main mapping",
            "additionalMappings": "Additional mappings",
            "newSheetName": "Sheet1",
            "specificFields": "Special fields",
            "environmentFieldLabel": "Environment message",
            "workflowFieldLabel": "Workflow message",
            "messages": {
                "mapOneInputFieldExcel": "EXCEL: Map at least one input field for excel",
                "mapOneOutputFieldExcel": "EXCEL: Map at least one output field for excel"
            }
        },
        "m3Api": {
            "unmappedRequiredInputs": "Following required inputs are not mapped: {inputs}",
            "removeStartEnd": "Disable start-end",
            "addStartEnd": "Enable start-end",
            "updateGrouping": "Extra grouping",
            "existingGroupings": "Field-level groupings",
            "extraGroupings": "Extra grouping",
            "apiGroupings": "API Item Groupings",
            "groupBy": "Group by this field",
            "selected": "selected",
            "hasGrouping": "Result will be grouped by this field",
            "runStartEndTitle": "Define start-end run",
            "selectTag": "Select tag",
            "defineStartEnd": "Define start-end run",
            "start": "Start transaction",
            "end": "End transaction",
            "deleteDependency": "Remove dependency",
            "fail": "fails",
            "success": "runs successfully",
            "condition": "Condition",
            "selectTransaction": "Transaction",
            "dependency": "Run \"{apiLabel}\" if",
            "updateDependency": "Dependencies",
            "deleteOutput": "Delete output - this field won't be available in lookups",
            "addOutput": "Add output - this field will become available in lookups",
            "sources": {
                "CONSTANT": "Constant",
                "CLIENT": "Client",
                "API": "Api",
                "EXCEL": "Excel",
                "TEXT": "Text",
                "EVENT": "Event",
                "CONTEXT": "Context",
                "TAG": "Tag",
                "CURRENT_DATE": "Current date",
                "_": "None"
            },
            "openFieldConfig": "Open parameter mapping config",
            "client": "Take value from",
            "newClientField": "New client field",
            "showGeneralTransactions": "Include general transactions",
            "parameterRequiredAndNotMapped": "Parameter required but not mapped",
            "parameterNotRequiredAndNotMapped": "Parameter not required and not mapped",
            "apiCall": "API call",
            "output": "Output parameter",
            "mappedOutputHeader": "Mapped output",
            "selectApiFirst": "Select api first",
            "constantValue": "Constant value",
            "constantValueRequired": "Constant value is required",
            "tagRequired": "Tag is required",
            "availableSources": "Available sources",
            "selectSource": "Select source",
            "removeSource": "Remove source",
            "sourceTitle": "Field configuration for {name}",
            "copyPrefix": " (copy %n)",
            "deleteApiConfirmation": "Are you sure that you want to delete API call?",
            "deleteApiHeader": "API call delete",
            "source": "Source",
            "value": "Value",
            "m3Company": "M3 Company",
            "m3Division": "M3 Division",
            "maxRows": "Max rows",
            "unlimited": "Unlimited",
            "companyMustBeNumeric": "M3 Company must be a numeric value",
            "executionConfig": "Execution config",
            "name": "Name",
            "configureExecution": "Configure execution",
            "addFirstApi": "Click here to add first API call",
            "noEnvironmentSelected": "No Environments Selected",
            "selectEnvironment": "Select Environment",
            "transactionSelectTitle": "Select transaction to run",
            "program": "Programs",
            "selectProgram": "Select program first",
            "transaction": "Transactions",
            "copy": "Copy",
            "setCritical": "Set critical",
            "unsetCritical": "Unset critical",
            "inputsHeader": "Inputs",
            "outputHeader": "Outputs",
            "addItem": "Add API item at this position",
            "eventColumn": "Event column",
            "title": "M3 API"
        },
        "transformerMorph": {
            "inputOrTemplateMissing": "Please provide input data and jsonata template",
            "title": "Transform",
            "input": "Input",
            "output": "Output",
            "help": "Learn JSONata syntax",
            "executionId": "Workflow execution id",
            "executionIdPrompt": "Load example data and simulate $context with actual values from an workflow execution",
            "transformation": "JSONata Expression",
            "loadExecution": "Load",
            "executionIdSuccessMessage": "Data loaded successfully for execution id {executionId}",
            "noExecutionFound": "No workflow execution found",
            "executionIdErrorMessage": "Error loading execution",
            "copyToClipboard": "Copy to clipboard",
            "copySuccessMessage": "JSONata expression copied to clipboard",
            "copyErrorMessage": "Error copying JSONata expression to clipboard"
        },
        "stepUpdated": "Step configuration updated successfully",
        "saveError": "Error saving workflow",
        "genericCode": {
            "title": "Step code editor"
        },
        "genericApi": {
            "title": "Rest API",
            "version": "Version",
            "versionDescription": "Component version",
            "connection": "Use connection",
            "connectionId": "Connection",
            "connectionPlaceholder": "Select or type a connection ID...",
            "endpoint": "Endpoint URL",
            "endpointPlaceholder": "https://api.example.com/path",
            "method": "HTTP Method",
            "methodWarning": "Unknown method. Expected a standard HTTP method or a handlebars expression",
            "headers": "Headers",
            "addHeader": "Add header",
            "headerKey": "Key",
            "headerValue": "Value",
            "bodyMode": "Request body",
            "bodyModeOption": {
                "bodyPath": "Body path",
                "body": "Body"
            },
            "bodyPathDescription": "Reference data from a previous step",
            "bodyDescription": "Define the request body",
            "bodyPathLabel": "JSONata body path expression",
            "bodyLabel": "Request body JSON",
            "advanced": "Advanced",
            "skipIfExpression": "Skip if expression",
            "skipIfExpressionDescription": "A JSONata expression that, if it evaluates to true, will skip this step",
            "forEach": "For each",
            "forEachDescription": "Path to an array from a previous step to iterate over (e.g. body.records)",
            "parallel": "Parallel executions",
            "parallelDescription": "Number of concurrent requests to run in parallel (max 20)"
        },
        "runtimeConfig": {
            "title": "Configure Runtime Environments",
            "basicTab": "Basic",
            "advancedTab": "Advanced",
            "basicDescription": "Assigns M3 environments to this workflow. Suitable for workflows that only use M3 steps.",
            "basicDisabledTooltip": "Basic settings cannot be enabled while Advanced settings are configured",
            "advancedDescription": "Connections are mapped per environment and automatically resolved when the app runs. Works with M3, Transform, and REST API steps. Can be used as ",
            "advancedDescriptionCode": "$context.runtime.connections.m3",
            "connectionAliases": "Connection Aliases",
            "connectionAliasesHelp": "Each system resolves at runtime to the connection mapped for the selected environment.",
            "alias": "System",
            "aliasPlaceholder": "Add another system",
            "aliasValidation": "Only lowercase letters, numbers, and underscores allowed",
            "aliasDuplicate": "This system already exists",
            "addAlias": "Add system",
            "environments": "Environments",
            "default": "Default",
            "setDefault": "Set as default",
            "connections": "Connection Mappings",
            "selectConnection": "Select connection...",
            "noAliasesYet": "No connection aliases defined yet. Add aliases above first.",
            "variables": "Variables",
            "variableKey": "Key",
            "variableValue": "Value",
            "addEnvironmentPlaceholder": "Add environment...",
            "emptyState": "Add an environment to get started. Connections will be auto-detected.",
            "noDefinitionError": "Workflow has no definition, cannot save."
        },
        "logsNotifications": "Logs and notifications",
        "executionKeys": "Execution keys",
        "executionLogs": "Execution logs",
        "notificationEmail": "Email for Error reports",
        "logLevelLabel": "Log level",
        "notifyOnError": "Notify on error",
        "logLevel": {
            "10": "Detailed",
            "30": "Info",
            "40": "Failures"
        },
        "markdownCode": "Markdown code",
        "markdownPreview": "Preview",
        "editInstructions": "Edit user instructions",
        "userInstructions": "User instructions",
        "saveUserInstructions": "Instructions saved successfully",
        "markdownGuidelines": "Markdown guidelines",
        "clientConfig": {
            "buttonDefaultText": "Execute",
            "descriptionDefaultText": "Description",
            "titleDefaultText": "Untitled"
        },
        "defineEnvironments": "Define environments",
        "summaryHeader": "Following workflow will be created:",
        "addActive": "Add Selected",
        "addAllActive": "Add all",
        "removeActive": "Remove Selected",
        "removeAllActive": "Remove all",
        "moveUp": "Move selected item up",
        "moveTop": "Move selected item to top",
        "moveDown": "Move selected item down",
        "moveBottom": "Move selected item to bottom",
        "isApi": "API",
        "setApi": "Use as environment for API",
        "primary": "Primary",
        "makePrimary": "Make primary",
        "apiEnvironment": "API Environment",
        "primaryEnvironment": "Primary Environment",
        "activeEnvironments": "Active environments",
        "availableEnvironments": "Available environments",
        "searchEnvironments": "Search environments",
        "loadErrorEnvironments": "Failed to load environments",
        "loadErrorEnvironmentsPermission": "You do not have permission to load environments. Please contact your administrator.",
        "loadErrorConnections": "Failed to load connections",
        "loadErrorConnectionsPermission": "You do not have permission to load connections. Please contact your administrator.",
        "templates": {
            "exportToExcel": {
                "title": "Export from M3 API",
                "description": "Export from a M3 API through a filter into a table"
            },
            "importToApi": {
                "title": "Import to M3 API",
                "description": "Import from the M3 API into a table"
            },
            "apiToTable": {
                "title": "Store data from M3 to Table",
                "description": "Export from the M3 API into a table"
            },
            "onAPI": {
                "title": "M3 API",
                "description": "Connect directly to the M3 API"
            },
            "transform": {
                "title": "Transform",
                "description": "Process and transform data between systems"
            },
            "empty": {
                "title": "Blank Start",
                "description": "Build a workflow from scratch"
            }
        },
        "templateGroups": {
            "multi": "Multi Component Templates",
            "single": "Single Component Templates"
        },
        "nameAndDescription": "Details",
        "template": "Templates",
        "environment": "Environments",
        "summary": "Summary",
        "stepsOverview": {
            "executionConfig": "Configure execution",
            "layout": {
                "horizontal": "Display horizontally",
                "vertical": "Display vertically"
            }
        },
        "triggerType": {
            "CLIENT": "Manual",
            "SCHEDULE": "Schedule",
            "EVENT": "Event",
            "WEBHOOK": "Webhook"
        },
        "editWorkflow": "Edit workflow",
        "openReadOnly": "Open read-only",
        "readOnly": {
            "label": "Read-only",
            "description": "This step configuration cannot be changed. Select and copy any value, or copy the full configuration.",
            "copyConfiguration": "Copy configuration",
            "copySuccess": "Step configuration copied to clipboard.",
            "copyError": "Could not copy the step configuration."
        },
        "deactivateWorkflow": {
            "header": "Deactivate workflow",
            "message": "Deactivating this workflow will also stop the scheduled runs of this workflow.",
            "confirm": "Yes, deactivate"
        },
        "workflowActivatedSuccess": "Workflow activated successfully",
        "workflowDeactivatedSuccess": "Workflow deactivated successfully",
        "hasError": "Workflow is misconfigured",
        "groups": "groups",
        "group": "group",
        "label": "label",
        "edit": "Edit",
        "run": "Run",
        "copy": "Copy",
        "favorite": "Add to favorites",
        "unfavorite": "Remove from favorites",
        "delete": "Delete",
        "deleteWorkflowSuccess": "Workflow deleted successfully",
        "deleteWorkflow": "Delete Workflow",
        "logsMenu": "Execution logs",
        "ago": "ago",
        "labels": "Labels",
        "addLabel": "Add a Label",
        "workflowInfo": "Workflow Info",
        "configuration": "Configuration",
        "options": "Options",
        "addUserInstructions": "Add New",
        "allWorkflows": "All Workflows",
        "api": {
            "addApi": "Add API",
            "alreadyExists": "already exists!",
            "apiOptions": "API Options",
            "basedOnTransaction": "Based on transaction",
            "code": "Code",
            "componentSettings": "Component settings",
            "connections": "Connections",
            "constant": "Constant",
            "critical": "Critical",
            "currentDate": "Current Date",
            "done": "Done",
            "editElement": "Edit element",
            "endRun": "End Run",
            "enterRows": "Enter rows",
            "enterValue": "Enter value",
            "environment": "Environment",
            "fromApi": "From API",
            "fromClient": "From Client",
            "fromEvent": "From Event",
            "fromExcel": "From Excel",
            "fromTag": "From Tag",
            "group": "Group",
            "groupedBy": "Grouped By",
            "includeGeneralTransactions": "Include General Transactions",
            "input": "Input",
            "inputs": "Inputs",
            "mapped": "Mapped",
            "max": "Max",
            "maxRows": "Max rows",
            "messages": {
                "configureOneTransaction": "API: Configure at least one Transaction",
                "mandatoryFieldNotMapped": "API: Mandatory field not mapped: {input}"
            },
            "name": "Name",
            "output": "Output",
            "outputs": "Outputs",
            "overview": "Overview",
            "pleaseEnterValue": "Please enter value",
            "program": "Program",
            "programName": "Program Name",
            "runOn": "Run On",
            "select": "Select",
            "selectSource": "Select Source",
            "source": "Source",
            "startRun": "Start Run",
            "transaction": "Transaction",
            "transactionName": "Transaction Name",
            "view": "View",
            "workflowSpreadsheet": "Workflow uses spread sheet data?"
        },
        "cancelEditor": "Cancel",
        "client": {
            "addFilterInput": "Add filter input",
            "addInput": "Add input",
            "apiDetails": "API Details",
            "browseControl": "Browse control",
            "buttonText": "Button Text",
            "changeText": "Change Text",
            "clientConfiguration": "Client configuration",
            "clientSettings": "Client settings",
            "customRequired": "Make Mandatory",
            "dateField": "Date field",
            "defaultValue": "Default value",
            "fields": "Fields",
            "input": "Input",
            "lookup": "Lookup",
            "placeholder": "Placeholder",
            "settings": "Settings",
            "tagField": "Tag",
            "textField": "Text field",
            "title": "Client",
            "tooltip": "Tooltip",
            "type": "Type"
        },
        "closeConfirmation": "Do you want to save pending changes?",
        "closeConfirmationTitle": "Please confirm",
        "closeEditor": "Close",
        "code": {
            "codeEditor": "Code editor"
        },
        "component": "Component",
        "componentSettings": "Component settings",
        "components": "Components",
        "connection": "Connection",
        "createdBy": "Created",
        "createdDate": "Created date",
        "deleteAPI": "Delete API",
        "deleteComponent": "Delete component",
        "deleteItem": "Are you sure that you want to delete \"{workflowName}\"?",
        "deleteItemFromDashboard": "Are you sure that you want to delete \"{workflowName}\"? This workflow is connected to Dashboard and {widgetCount} {widgetText}.",
        "deleteItemAPI": "Do you want to delete the API {APIName}?",
        "deleteUserInstructions": "Delete",
        "deleteUserInstructionsConfirmationMessage": "This action will delete the user instructions permanently, are you certain that you want to proceed?",
        "deleteUserInstructionsConfirmationTitle": "Confirm Deletion",
        "description": "Workflow Description",
        "editor": {
            "addComponent": "Add Component",
            "fetch": "Fetch",
            "api": "M3 API",
            "code": "Code",
            "componentToStartWorkflow": "Select a Component to start from workflow",
            "converter": "Converter",
            "createFromScratch": "...Or Create from Scratch",
            "createFromTemplate": "Create from Template...",
            "dataLake": "Data lake",
            "database": "Database",
            "email": "Email",
            "excel": "Excel",
            "exportToExcel": "Export from M3",
            "fileLoader": "File Loader",
            "filter": "M3 Filter",
            "genericFilter": "Generic Filter",
            "importToAPI": "Import to M3",
            "lookup": "Lookup",
            "notification": "Notification",
            "restApi": "Rest API",
            "sms": "SMS",
            "storeApiToTable": "Store data from M3 to Table",
            "table": "Table",
            "tableUpdater": "Table updater",
            "transform": "Transform",
            "trigger": "Trigger",
            "widget": "Widget"
        },
        "enterDescription": "Enter description",
        "enterEmail": "Enter email",
        "enterName": "Enter name",
        "event": {
            "eventConfiguration": "Event Configuration",
            "title": "Event"
        },
        "execute": {
            "advanced": "Advanced",
            "browse": "Browse",
            "chooseTheFile": "Choose a file",
            "dropTheFile": "Drop file here...",
            "logLevel": "Log Level",
            "logLevelList": {
                "detailed": "Detailed",
                "failures": "Failures",
                "info": "Info"
            },
            "resultDetails": {
                "title": "Result details (JSON)"
            },
            "logs": {
                "title": "M3 Logs"
            },
            "result": {
                "executionNotFound": "Data for execution not found",
                "done": "Done",
                "duration": "Duration",
                "failedRecords": "Failed Records:",
                "files": "Files",
                "recordsProcessed": "Records Processed:",
                "stepId": "Step ID",
                "success": "Step Success:",
                "successfulRecords": "Successful Records:",
                "title": "Results",
                "trigger": "Trigger File",
                "waitingToStart": "Waiting to start",
                "workflowEnded": "Workflow ended",
                "workflowFailed": "Workflow failed!",
                "workflowRunning": "Workflow running...",
                "workflowRunningInBackground": "Workflow is still running in the background.",
                "workflowStarted": "Workflow started",
                "failedToDownloadTriggerFile": "Failed to download trigger file",
                "noTriggerFile": "No trigger file available"
            },
            "schedule": {
                "daily": {
                    "day": "day",
                    "title": "Daily"
                },
                "day": "Day",
                "every": "Every",
                "everyWeekDay": "Every week day",
                "hourly": {
                    "hour": "hour",
                    "title": "Hourly"
                },
                "minutes": {
                    "minutes": "minutes",
                    "title": "Minutes"
                },
                "monthly": {
                    "month": "month",
                    "title": "Monthly"
                },
                "monthsOptions": {
                    "april": "April",
                    "august": "August",
                    "december": "December",
                    "february": "February",
                    "january": "January",
                    "july": "July",
                    "june": "June",
                    "march": "March",
                    "may": "May",
                    "november": "November",
                    "october": "October",
                    "september": "September"
                },
                "of": "of",
                "ofEvery": "of every",
                "periodOptions": {
                    "first": "First",
                    "fourth": "Fourth",
                    "second": "Second",
                    "third": "Third"
                },
                "scheduler": "Scheduler",
                "startTime": "Start time",
                "the": "The",
                "weekly": {
                    "friday": "Friday",
                    "monday": "Monday",
                    "saturday": "Saturday",
                    "sunday": "Sunday",
                    "thursday": "Thursday",
                    "title": "Weekly",
                    "tuesday": "Tuesday",
                    "wednesday": "Wednesday"
                },
                "yearly": {
                    "title": "Yearly"
                }
            }
        },
        "export": "Export",
        "failure": "Failure",
        "fileLoader": {
            "fileLoader": "File Loader",
            "messages": {
                "info": "If the folder has multiple files, the most recently edited will be picked by default",
                "missingConnection": "FILE LOADER: Please select a connection",
                "missingFile": "FILE LOADER: Please select a file"
            }
        },
        "filter": {
            "action": "Action",
            "all": "All",
            "field": "Field",
            "fieldSource": {
                "constant": "Constant",
                "fromClient": "From Client"
            },
            "filterConditions": {
                "blank": "Is Blank",
                "contains": "Contains",
                "doesNotContain": "Does Not Contain",
                "equal": "Equal",
                "greaterThan": "Greater Than",
                "greaterThanEqual": "Greater than Equal",
                "lessThan": "Less Than",
                "lessThanEqual": "Less than Equal",
                "notBlank": "Is Not Blank",
                "notEqual": "Not Equal"
            },
            "filterConfiguration": "Filter configuration",
            "logicalType": "Logical Type",
            "logicalTypes": {
                "and": "AND",
                "or": "OR"
            },
            "messages": {
                "mapOneFieldFilter": "M3 FILTER: Map at least one field to filter.",
                "missingConstantValue": "M3 FILTER: Missing value for Constant in {filterDescription}",
                "missingLogicalType": "M3 FILTER: Missing Logical Type for {filterDescription}",
                "missingSource": "M3 FILTER: Missing source for {filterDescription}",
                "missingType": "M3 FILTER: Missing Type for {filterDescription}"
            },
            "noApiFound": "No API found",
            "selectFields": "Select Fields",
            "source": "Source",
            "type": "Type"
        },
        "filterText": "Filter",
        "filters": "Filters",
        "import": "Import",
        "inputFields": "Input fields",
        "invalidWorkflow": "Invalid workflow",
        "lastExecuted": "Last executed",
        "logLevelList": {
            "detailed": "Detailed",
            "failures": "Failures",
            "info": "Info"
        },
        "logs": {
            "lessThenSecond": "Less than a second",
            "AvgTimePerRecord": "AvgTimePerRecord",
            "AvgTimePerTransaction": "AvgTimePerTransaction",
            "action": "Action",
            "auditLogs": "Audit Logs",
            "downloadDataContents": "Download data contents",
            "durationMs": "Duration",
            "endTime": "End time",
            "environmentLogs": {
                "rerunEnvironment": {
                    "title": "Confirm Re-run"
                }
            },
            "fails": "Fails",
            "joblog": "Job Log",
            "logDetails": "Log details",
            "logType": "Log Type",
            "logTypeList": {
                "all": "All",
                "failed": "Failed",
                "ok": "Success",
                "verified": "Verified",
                "retried": "Retried",
                "started": "Started"
            },
            "logs": "Logs",
            "message": "Message",
            "program": "Program",
            "startTime": "Start time",
            "status": "Status",
            "success": "Success",
            "time": "Time",
            "title": "Workflow logs",
            "transaction": "Transaction",
            "type": "Type",
            "rerun": "Re-Run Workflow",
            "verify": "Mark as Verified",
            "copyLink": "Copy link to log",
            "resultJson": {
                "errorTitle": "Failed to download result details",
                "download": "Download Result Details",
                "copyToClipboard": "Copy to clipboard",
                "copySuccessMessage": "Result details copied to clipboard",
                "copyErrorMessage": "Error copying result details to clipboard"
            },
            "errorLoading": "Error loading M3 logs",
            "findOriginal": "Find original"
        },
        "manual": "Manual",
        "messages": {
            "configureOneComponent": "Please configure at least one component",
            "couldNotSaveWorkflow": "Could not save the workflow!",
            "enterNotificationEmail": "Please enter notification Email",
            "enterValidWorkflow": "Please enter a valid workflow name.",
            "errorOccured": "Error occured while executing the workflow!",
            "executionComplete": "Execution complete!",
            "fileNotFound": "File or directory not found. Please check if the uploaded file exists or has been renamed.",
            "invalidGenericFilter": "Please select logical type for all the rows in Generic Filter",
            "invalidValue": "Invalid value %{input} for the field %{field}.",
            "m3APIMaxRowAlertText": "If you want more than 99,999 records, please select the \"Unlimited\" checkbox.",
            "mandatoryFieldmandatoryField": "Please enter the mandatory field %{field}.",
            "maxValueExceed": "Value {input} for the field {field} has exceeded the maximum length {length}.",
            "permissionError": "User/role does not have permissions to {errorMessage}",
            "schdulerSavedWithErrors": "Error occurred in Scheduler configuration",
            "schedulerDelete": "Scheduler deleted successfully",
            "schedulerErrorAlertText": "{input} has missing values",
            "schedulerSavedSuccessfully": "Scheduler configured successfully",
            "specialCharError": "Special character's  / $ * ? {'{ }'} [ ]  not allowed in Workflow Name",
            "workflowNameExists": "Workflow name {workflowName} already exists!",
            "workflowNameRequired": "Workflow name is required",
            "workflowSavedSuccessfully": "Workflow saved successfully!",
            "workflowSavedWithErrors": "Workflow saved with following errors:"
        },
        "modifiedBy": "Modified",
        "name": "Name",
        "navguardWarning": "You seem to have unsaved changes that will be lost if you leave this page. Do you wish to discard the changes and continue?",
        "newWorkflow": "New Workflow",
        "outputFields": "Output fields",
        "preview": "Preview",
        "previewData": "Preview Data",
        "recentlyViewed": "Recently Viewed",
        "favorites": "Favorites",
        "restApi": {
            "restApiConfiguration": "Rest API"
        },
        "runBy": "Run by",
        "scheduled": "Scheduled",
        "select": "Select",
        "settings": {
            "retryAttemptsNegetiveNumberValidation": "Should not be below 0.",
            "retryAttemptsPositiveNumberValidation": "Should not Exceed to limit 5."
        },
        "sms": {
            "maxlengthWarning": "{messageLength}/160 characters",
            "messages": {
                "contentMaxLengthError": "SMS: content cannot exceed 160 characters",
                "invalidRecipientNumber": "Invalid phone number",
                "noContentError": "SMS: Content field cannot be blank",
                "noRecipientsError": "SMS: Recipients cannot be empty"
            },
            "recipientsLabel": "Enter Recepients Phone Number",
            "recipientsPlaceholder": "+1234567890",
            "smsConfiguration": "SMS Configuration",
            "smsContentPlaceholder": "Enter the message",
            "smsLabel": "Message",
            "saveMessage": "Save Message"
        },
        "status": {
            "active": "Active",
            "all": "All",
            "inactive": "Deactivated",
            "title": "Status"
        },
        "success": "Success",
        "title": "Workflows",
        "transform": {
            "transformConfiguration": "Transform",
            "trimAllInputValues": "Trim all input values before transformation"
        },
        "actions": {
            "delete": "Delete",
            "create": "Create",
            "update": "Update"
        },
        "rule": {
            "field": "Field",
            "condition": "Condition",
            "value": "Value"
        },
        "availableFields": {
            "title": "Available fields",
            "selected": "parameters selected"
        },
        "logicalOperatorOptions": {
            "AND": "And",
            "OR": "Or"
        },
        "m3filter": {
            "newValue": "Value",
            "newConstant": "New",
            "noM3ApiItems": "No filter items available without M3 API defined",
            "dragItems": "Filter currently does not have any filter items.",
            "clickToShow": "Click here to show available fields list",
            "dropBelow": "Drag item below to add filter",
            "filterItems": "Filter items",
            "globalFilter": "Global filter",
            "constant": "Constant",
            "defaultValue": "Default value",
            "valueSourceOptions": {
                "CLIENT": "Client",
                "CONSTANT": "Constant"
            },
            "comparisonOptions": {
                "EQ": "Equals",
                "NE": "Not equals",
                "LT": "Less than",
                "GT": "Greater",
                "LE": "Less or equals",
                "GE": "Greater or equals",
                "BLANK": "Blank",
                "NOTBLANK": "Not blank",
                "CONTAINS": "Contains",
                "NOTCONTAINS": "Does not contain"
            },
            "source": "Source",
            "logicalOperator": "Logical operator",
            "comparison": "Comparison",
            "title": "Filter",
            "openFields": "Show available fields",
            "closeFields": "Close fields list",
            "constantValueRequired": "Constant value is required for field: {field}",
            "noFieldsMappedWarning": "No fields are mapped. Please map at least one field for the M3 filter or remove the M3 filter."
        },
        "trigger": {
            "lookupAlreadyExists": "Lookup with the same name already exists",
            "lookupNameRequired": "Lookup name is required",
            "noClientInputs": "No client inputs configured yet",
            "selectNewWorkflow": "Select new workflow",
            "selectSource": "Select source",
            "lookupNotAvailable": "Lookup is not available. The workflow was not found or is inactive.",
            "workflowNotFound":"The selected workflow is unavailable. Please choose a new workflow.",
            "valueNotRequired": "Value not required",
            "apiRequired": "API requires this field to be mandatory",
            "lookupDeleteConfirmation": {
                "message": "Are you sure that you want delete lookup configuration?",
                "header": "Lookup configuration delete"
            },
            "inputs": "Inputs",
            "outputs": "Outputs",
            "mappings": "Mappings",
            "workflow": "Workflow",
            "lookupName": "Lookup Name",
            "addLookup": "Add lookup",
            "lookups": "Existing lookups:",
            "selectedLookup": "Selected lookup:",
            "selectLookup": "Select lookup to view its configuration",
            "noLookups": "No lookups configured. Click <b>here</b> to add first",
            "lookupHeader": "Configure lookups",
            "inputFile": "Select input file",
            "tagValueNotFound": "User has no required tag",
            "formFieldType": {
                "text": "Text",
                "date": "Date",
                "browse": "Select",
                "tag": "Tag"
            },
            "preview": "Preview",
            "editField": "Edit field",
            "selectTag": "User tag to use as value",
            "defaultValue": "Default value",
            "label": "Label",
            "tooltip": "Tooltip",
            "mandatory": "Required",
            "placeholder": "Placeholder",
            "length": "Max length",
            "type": "Type",
            "noFieldsAvailable": "All fields have been assigned already",
            "noAssignableFieldsAvailable": "Workflow does not contain any fields that can be configured",
            "groups": {
                "fields": "Fields",
                "filters": "Filters",
                "default-inputs": "Default"
            },
            "clientPreview": "Client preview",
            "availableFields": "Available fields",
            "addParameters": "Add fields",
            "lookupConfig": "Configure lookups",
            "filters": "Filters",
            "source": "Trigger source",
            "columns": "Trigger on changes for the following column",
            "noEventColumnsAvailable": "No event columns available. Please configure an Event trigger with columns first.",
            "table": "Table",
            "actions": "Actions",
            "actionsRequired": "Actions is a mandatory field",
            "nextRuns": "Next Scheduled Runs",
            "start": "Start date/time",
            "end": "End date/time",
            "schedule": "Schedule",
            "timeZone": "Timezone",
            "autoTimeZone": "Automatic timezone",
            "messages": {
                "triggerType": "TRIGGER: Please select a Trigger Type"
            },
            "title": "Trigger",
            "triggerConfiguration": "Trigger Configuration",
            "filtering": "Filtering",
            "filterTooltip": "You can only have Filter or Expression. Choosing one will eliminate the other",
            "emptyFilterPlaceholder": "No filters or expression are applied. Click Filters or Expression to create condition. Choosing one will eliminate the other",
            "addFilter": "Add Filter",
            "maximizeEditor": "Maximize Editor",
            "invalidExpression": "Invalid JSONata expression",
            "events": {
                "FILTER": "Filter",
                "EXPRESSION": "Expression"
            },
            "scheduledWorkflowRuns": "Scheduled Workflow Runs",
            "scheduleDescription": "Please enter how often you would like to schedule the workflow to run",
            "scheduledRuns": "Scheduled Runs",
            "noScheduledRuns": "No Scheduled Runs",
            "clearSelection": "Clear Selection",
            "replaceNotAvailable": "Trigger events are not available for REPLACE"
        },
        "updateUserInstructions": "Update",
        "value": "Value",
        "version": "Version",
        "widget": {
            "addNewState": "Add new state",
            "additionalInfo": "Color for foreground text and icon",
            "aggregateType": "Aggregate Type",
            "backgroundColor": "Background color",
            "color": "Color",
            "count": "Count",
            "createWidget": "Create widget",
            "customBackgroundColor": "Custom background color",
            "dashboardUpdateInterval": "Dashboard update interval(seconds)",
            "data": "Data",
            "dataCount": "Font size for data count",
            "defaultBackgroundColor": "Default background color",
            "deleteDraft": "Delete draft",
            "displayValue": "Display Value",
            "documentation": "Documentation",
            "editState": "Edit state",
            "fontSize": "Font Size",
            "foregroundColor": "Text color",
            "icon": "Icon",
            "iconSettings": "Icon settings",
            "interval": "Interval",
            "label": "Label",
            "labelsMax": "labels (max 25)",
            "max": "Max",
            "min": "Min",
            "newState": "New state",
            "noStatesDefined": "No states are defined",
            "normalized": "Normalized",
            "pollingCountWithoutChanges": "Polling count without changes before warning",
            "range": "Range",
            "rangeFrom": "Range from",
            "rangeTo": "Range to",
            "scales": "Scales",
            "selectWidgetType": "Select widget type",
            "show": "Show",
            "sortBy": "Sort By",
            "stacked": "Stacked",
            "states": "States",
            "tableName": "Custom Tables",
            "titleSize": "Header font size",
            "type": "Type",
            "viewDetails": "View details",
            "widgetField": "Field",
            "widgetTitle": "Title",
            "xAxisConfigure": "Configure X-Axis",
            "yAxisConfigure": "Configure Y-Axis"
        },
        "workflow": "Workflow",
        "workflowActions": {
            "downloadTemplate": "Download Template",
            "execute": "Execute",
            "log": "Log",
            "manageRoles": "Manage roles",
            "move": "Move",
            "reRun": "Re-run",
            "rename": "Rename",
            "run": "Run",
            "schedule": "Schedule"
        },
        "workflowDescription": "Workflow description",
        "workflowName": "Workflow Name",
        "copyInfo": "You can either change the workflow name or use the suggested name to continue.",
        "copyWorkflow": "Copy Workflow",
        "enterCopyName": "Workflow name",
        "nameExists": "Workflow name already in use. Please select a unique name.",
        "copySuccess": "Workflow '{name}' copied successfully.",
        "copyError": "Failed to copy workflow.",
        "longRunning": "Long Running",
        "longRunningMessage": "Handles long-running and high-capacity workloads",
        "expressMessage": "Good for quick operations but may fail on long or heavy workloads due to runtime limits.",
        "longRunningTooltip": "Enable for large Excel imports (30,000+ rows) that may exceed 15 minutes."
    },
    "workflowStatistics": {
        "statistics": "Workflow Statistics",
        "lastExecutionTime": "Last Execution Time",
        "lastSuccessfulTime": "Last Successful Time",
        "lastFailedTime": "Last Failed Time",
        "totalRuns": "Total Runs",
        "totalRunsTooltip": "Total workflow runs",
        "successfulRunsTooltip": "Successful workflow runs",
        "failedRunsTooltip": "Failed workflow runs",
        "viewLog": "View Log"
    }
}
